import ObjectArray from './ObjectArray';

export default ObjectArray;
